(<template>
  <form-template :title="title"
                 :progress="progressActive">
    <div class="choose-role"
         :class="{'choose-role--center': isCourtTheme}">
      <role-btn v-for="btn in roleButtons"
                :key="btn.type"
                :params="btn"
                @click.native="sendRole(btn.type)" />
    </div>
  </form-template>
</template>)

<script>
  import {mapGetters, mapActions} from 'vuex';
  import WizardFormTemplate from '@/components/wizard_components/WizardFormTemplate';
  import WizardChooseRoleBtn from '@/components/wizard_components/WizardChooseRoleBtn';

  export default {
    components: {
      'form-template': WizardFormTemplate,
      'role-btn': WizardChooseRoleBtn
    },
    data() { return {progressActive: false}; },
    computed: {
      ...mapGetters('UserInfoStore', ['currentRole', 'userUid', 'isCourtTheme']),
      title() { return !this.isCourtTheme ? this.$gettext('Choose your role') : ''; },
      roleButtons() {
        const buttons = [
          {
            type: 'server',
            title: !this.isCourtTheme ? this.$gettext('Interpreter or Translator') : this.$gettext('Interpreter'),
            description: this.$gettextInterpolate(this.$gettext('Professionals who want to offer interpretation or translation services through the %{domain} platform.'), {domain: this.$getString('domainData', 'platformName')}),
            btnText: this.$gettext('Create account'),
            condition: true
          },
          {
            type: 'employee',
            title: this.$gettext('Organization'),
            description: this.$gettext('Companies or institutions looking to manage and request language services on behalf of their organization.'),
            btnText: this.$gettext('Create account'),
            condition: !this.isCourtTheme
          },
          {
            type: 'buyer',
            title: this.$gettext('Private Person'),
            description: this.$gettext('Individuals seeking interpretation or translation services for personal use.'),
            btnText: this.$gettext('Create account'),
            condition: !this.isCourtTheme
          }
        ];
        return buttons.filter((button) => button.condition);
      },
    },
    methods: {
      ...mapActions('TTWizardStore', ['setRole']),
      sendRole(role) {
        this.progressActive = true;
        this.setRole(role).then(() => {
          this.$store.dispatch('UserInfoStore/fetchUserInfo', this.userUid).then(() => {
            const name = this.currentRole === 'server' ? 'ServerWizardEnterName' : 'BuyerWizardEnterName';
            this.$router.replace(this.$makeRoute({name}));
          });
        }).catch((error) => {
          if (error.data?.errors?.no_other_role?.includes('User has other role')) {
            this.$store.commit('InfoModalStore/setInfoModal', {
              text: this.$gettext('Looks like you already have an account type. Please reload the page to continue the sign up process.')
            });
          } else {
            this.progressActive = false;
            this.$store.commit('ModalStore/setModal', {
              component: 'error-modal',
              data: {
                error
              }
            });
          }
        });
      }
    }
  };
</script>

<style scoped>
  .choose-role {
    display: flex;
    gap: 0 10px;
    justify-content: space-between;
    width: calc(100% - 80px);
    margin: 0 auto;
  }

  .choose-role--center {
    justify-content: center;
  }

  @media (max-width: 670px) {
    .choose-role {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: calc(100% - 28px);
    }
  }
</style>
